import FindYourHome from "../screens/vscFindYourHome/FindYourHome";
import * as React from "react";
import {useCommunityData} from "./CommunityDataLoader";


export interface IVscLotsProps {


}
const slsOrdMock =[
        {baths: "9", bedrooms: "1", id:"abc", reservedTo: 0, waitlist: [], price: 100000, style: "X", sqf: "1234", options: [],
            blockNumber: "X", lotNumber: "12", images: {elevation: 'x', firstFloor: 'x', secondFloor: 'x'}, isSold: false, marketingName: "Prism", modelRid: 123}
        ];

export const VscLots: React.FC<IVscLotsProps> = (props) => {

    const communityInfo = useCommunityData();
    if (communityInfo === null) return <div>Loading</div>
    if (communityInfo.views === undefined || communityInfo.views === null) {
        return <div>Unable to render community view - no views configured! (views key missing from community.json configuration)</div>
    }
    if (communityInfo.views.length === 0) {
        return <div>Unable to render community view - no views configured! (views array empty in community.json configuration)</div>
    }
    return <FindYourHome
            slsOrds={communityInfo.homes}
            viewItems={communityInfo.views ?? []}
            map={communityInfo.map}
            favorites={new Set()}
            features={communityInfo.features ?? ["markethomes", "floorplans"]}
            updateFavorites={() => 0} />
}

